export enum ScrollWindowAxis {
  x = "x",
  y = "y",
  xy = "xy",
}

export type ScrollWindowAxisOptions = keyof typeof ScrollWindowAxis;
